module.exports = __webpack_public_path__ + "img/land_tower.e88e7426.png";